import { render, staticRenderFns } from "./FTPStep.vue?vue&type=template&id=3853ab80"
import script from "./FTPStep.vue?vue&type=script&lang=js"
export * from "./FTPStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports